import { render, staticRenderFns } from "./VideoInfoViewer.vue?vue&type=template&id=5263d792&scoped=true&"
import script from "./VideoInfoViewer.vue?vue&type=script&lang=ts&"
export * from "./VideoInfoViewer.vue?vue&type=script&lang=ts&"
import style0 from "./VideoInfoViewer.vue?vue&type=style&index=0&id=5263d792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5263d792",
  null
  
)

export default component.exports